import { Component, OnInit } from '@angular/core';
import { RepositoryService } from './../../shared/services/repository.service';
import { Risk, Risk as IRisk } from "../../_interfaces/risk.model";

@Component({
  selector: 'app-emerging-risks',
  templateUrl: './emerging-risks.component.html',
  styleUrls: ['./emerging-risks.component.css']
})
export class EmergingRisksComponent implements OnInit {
    dataSource4: Object;
    public risks: Risk[];
    public riskType: number;

    constructor(private repository: RepositoryService) {


  }

    ngOnInit() {
      this.getEmergingRiskChartData();
      //  this.SetTestData();
      this.getEmergingRisks();
    }


  public getEmergingRiskChartData() {
      let apiAddress: string = `Risks/Emerging/BubbleChart`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
          this.dataSource4 = res ;
      });
  }

    public SetTestData() {
        this.dataSource4 = {
            chart: {
                theme: "fusion",
                caption: "Emerging Risk Projection",
                subcaption: "For Next 12 Months",
                xaxisminvalue: "0",
                xaxismaxvalue: "100",
                yaxisminvalue: "0",
                yaxismaxvalue: "100",
                showValues: "1",
                xaxisname: "Proximity",
                yaxisname: "Probability",
                plottooltext: "$name : Risk Impact: $zvalue",
                drawquadrant: "1",
                quadrantlabeltl: "High Probability / High Proximity",
                quadrantlabeltr: "High Probability / Low Proximity",
                quadrantlabelbl: "Low Probability / High Proximity",
                quadrantlabelbr: "Low Probability / Low Proximity",
                quadrantxval: "50",
                quadrantyval: "50",
                quadrantlinealpha: "50",
                quadrantlinethickness: "2"
            },
            categories: [
                {
                    category: [
                        {
                            label: "Immediate",
                            x: "0"
                        },
                        {
                            label: "Near",
                            x: "20",
                            showverticalline: "1"
                        },
                        {
                            label: "Mid",
                            x: "40",
                            showverticalline: "1"
                        },
                        {
                            label: "Long",
                            x: "60",
                            showverticalline: "1"
                        },
                        {
                            label: "Emergent",
                            x: "80",
                            showverticalline: "1"
                        },
                        {
                            label: "Distant",
                            x: "100",
                            showverticalline: "1"
                        }
                    ]
                }
            ],
            dataset: [
                {
                    data: [
                        {
                            x: "80",
                            y: "75",
                            z: "24",
                            name: "Brexit",
                            color: "#13243a"
                        },
                        {
                            x: "60",
                            y: "80",
                            z: "26",
                            name: "Consumer Confidence",
                            color: "#33ccff"
                        },
                        {
                            x: "50",
                            y: "19",
                            z: "19",
                            name: "CTF"
                        },
                        {
                            x: "65",
                            y: "10",
                            z: "8",
                            name: "Market"
                        },
                        {
                            x: "43",
                            y: "27",
                            z: "5",
                            name: "Interest Rates"
                        },
                        {
                            x: "32",
                            y: "42",
                            z: "10",
                            name: "Inflation"
                        },
                        {
                            x: "44",
                            y: "23",
                            z: "9",
                            name: "FTSE Volatility"
                        }
                    ]
                }
            ],
            trendlines: [
                {
                    line: [
                        {
                            startvalue: "20",
                            endvalue: "30",
                            istrendzone: "1",
                            color: "#aaaaaa",
                            alpha: "14"
                        },
                        {
                            startvalue: "10",
                            endvalue: "20",
                            istrendzone: "1",
                            color: "#aaaaaa",
                            alpha: "7"
                        }
                    ]
                }
            ]
        };
    }

    public getEmergingRisks() {
      this.riskType = 0; //
        let apiAddress: string = `Risks/Emerging`; // ToDo - add html code for list
        this.repository.getData(apiAddress)
        .subscribe(res => {
          this.risks = res as Risk[];
        });
  }
  public addEmergingRisk() {
    // riskStatus = 1; // Emerging Risk (i.e. not Active risk)

  }
}
